<div class="modal-content">
  <div class="modal-toggle-wrapper social-profile text-start dark-sign-up">
    <h4 class="modal-header justify-content-center border-0 text-dark">Relacione seu ticket a um ticket existente</h4>
    <div class="modal-body">
      <div class="search-bar" [formGroup]="headerForm">
        <div class="search-container">
            <input class="form-control" formControlName="searchControl" type="text" (keydown.enter)="searchClick()" placeholder="Pesquisar no RealDesk">
            <!-- Mensagem ao lado do input -->
            <div *ngIf="isSearchControlNotEmpty()" class="search-message" [@slideInOut]>
                Digite Enter para realizar a busca
            </div>
        </div>
        <!-- Lista de resultados -->
        <div *ngIf="searchResults?.length && showResults" class="search-results">
            <ul>
                <li *ngFor="let item of searchResults" 
                style="display: flex; flex-direction: row;"
                (click)="toggleSelection(item.IdTicket)" >
                  <input type="checkbox" style="margin: 5px;"
                        [checked]="isSelected(item.IdTicket)" 
                      />
                    <div class="ticket-item">
                        <div><strong>#{{item.IdTicket}}</strong></div>
                        <div class="ticket-subject">Assunto: {{item.Assunto}}</div>
                    </div>
                </li>
            </ul>
        </div>
      </div>


    </div>
    <div class="modal-footer d-flex justify-content-between align-items-center">

      <div>
        <button class="btn btn-secondary me-2" (click)="closeModal()">Cancelar</button>
       
        <button 
        class="btn btn-primary" 
        [disabled]="selectedTickets.length === 0" 
        (click)="confirmSelection()"
        >
            Associar Ticket
        </button>     
      </div>
    </div>
    
  </div>
</div>
